// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__K-OTx {
  cursor: pointer;
  display: flex;
  align-items: center;
  align-self: center;
  gap: 12px;
}

.styles_text__UvYzr {
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  white-space: nowrap;
  color: #443de9;
}

.styles_arrow__fciYl {
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./src/components/sideMenu/menuCtrl/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AADF;;AAIA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mBAAA;EACA,cCMK;ADPP;;AAIA;EACE,yBAAA;AADF","sourcesContent":["@import './src/assets/styles/variables/colors';\n\n.wrapper {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  align-self: center;\n  gap: 12px;\n}\n\n.text {\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  white-space: nowrap;\n  color: $blue;\n}\n\n.arrow {\n  transform: rotate(180deg);\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__K-OTx`,
	"text": `styles_text__UvYzr`,
	"arrow": `styles_arrow__fciYl`
};
export default ___CSS_LOADER_EXPORT___;
